(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[190],{

/***/ 76362:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/add-a-installer",
      function () {
        return __webpack_require__(92362);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26626);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_withPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68262);
/* harmony import */ var _src_components_checkout_components_EmailInput_email_input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53775);
/* harmony import */ var _src_components_checkout_components_TextInput_text_input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56073);
/* harmony import */ var _src_components_modals_FeedbackModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40456);
/* harmony import */ var _src_components_page__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13366);
/* harmony import */ var _src_redux_actions_filters__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(44849);
/* harmony import */ var _src_redux_actions_search__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(44743);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(87066);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14416);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(12338);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86501);
/* harmony import */ var simple_react_validator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41283);
/* harmony import */ var simple_react_validator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(simple_react_validator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2962);
/* harmony import */ var _src_components_checkout_components_PhoneInput_phone_input__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19405);
/* harmony import */ var _src_redux_constants_actiontypes__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(45703);
/* harmony import */ var _src_bigcommerce_api_checkout_get_checkout__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59133);




























var businessTypesData = [
    {
        value: "1",
        label: "Car Battery Installer"
    }
];
var categoriesInfo = {
    name: "Categories:",
    id: -1
};
var AddInstaller = /*#__PURE__*/ function(Page) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(AddInstaller, Page);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(AddInstaller);
    function AddInstaller(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(this, AddInstaller);
        var _this;
        _this = _super.call(this, props);
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_this), "onOpenModal", function() {
            _this.setState({
                modalOpen: true
            });
        });
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_this), "onCloseModal", function() {
            _this.setState({
                firstName: "",
                lastName: "",
                email: "",
                phoneNumber: "",
                businessName: "",
                addressLine1: "",
                addressLine2: "",
                city: "",
                state: "",
                postalCode: "",
                loading: false,
                modalOpen: false
            });
        });
        var _this1 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_this);
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_this), "submitForm", /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function() {
            var payload, apiPath, result;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        payload = _this1.state;
                        apiPath = "https://api.marketring-api.com/v1/ProviderLocations/create/installer";
                        if (!_this1.validator.allValid()) return [
                            3,
                            2
                        ];
                        //TODO: submit the form
                        _this1.setState({
                            loading: true
                        });
                        console.log(apiPath, JSON.stringify(payload));
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_20__/* ["default"].post */ .Z.post(apiPath, payload, {
                                crossdomain: true
                            }).then(function(response) {
                                _this1.setState({
                                    modalOpen: true
                                });
                                return response.data;
                            }).catch(function(error) {
                                console.log(error);
                                _this1.setState({
                                    loading: false
                                });
                                react_hot_toast__WEBPACK_IMPORTED_MODULE_8__/* ["default"].error */ .ZP.error("Error Submitting Form - Please Try Again.");
                                return error;
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _this1.validator.showMessages();
                        _this1.forceUpdate();
                        return [
                            2,
                            false
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        }));
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_this), "handleChange", function(evt) {
            var value = evt.target.value;
            _this.setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, _this.state), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, evt.target.name, value)));
        });
        _this.state = {
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            country: "",
            businessName: "",
            addressLine1: "",
            addressLine2: "",
            city: "",
            state: "",
            postalCode: "",
            loading: false,
            modalOpen: false
        };
        _this.validator = new (simple_react_validator__WEBPACK_IMPORTED_MODULE_9___default())({
            autoForceUpdate: (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_this),
            locale: "en"
        });
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(AddInstaller, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function() {
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.assignCountry()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function() {
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(nextProps.countries != _this.props.countries)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.assignCountry()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "assignCountry",
            value: function assignCountry() {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function() {
                    var countrycheck, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                countrycheck = _this.props.countries;
                                if (!(_this.props.countries.length == 0)) return [
                                    3,
                                    2
                                ];
                                ////// HACK CAUSE ANNOYED
                                return [
                                    4,
                                    (0,_src_bigcommerce_api_checkout_get_checkout__WEBPACK_IMPORTED_MODULE_12__/* .getCountries */ .ox)().then(function(response) {
                                        countrycheck = response;
                                    }).catch(function(error) {
                                        console.log(error);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                result = countrycheck.find(function(param) {
                                    var country_iso2 = param.country_iso2;
                                    return country_iso2 === _this.state.country ? _this.state.country.country_iso2 : _this.props.geolocation.country ? _this.props.geolocation.country : "US";
                                });
                                return [
                                    4,
                                    _this.setState({
                                        country: result
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _state = this.state, firstName = _state.firstName, lastName = _state.lastName, email = _state.email, phoneNumber = _state.phoneNumber, country = _state.country, businessName = _state.businessName, addressLine1 = _state.addressLine1, addressLine2 = _state.addressLine2, city = _state.city, state = _state.state, postalCode = _state.postalCode, taxId = _state.taxId, companyName = _state.companyName;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "page add-business add-installer",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_10__/* .NextSeo */ .PB, {
                            title: "Become an Installer | 1-800-Battery"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_modals_FeedbackModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            open: this.state.modalOpen,
                            type: "success",
                            title: "Success",
                            content: "Your Installer Account has been created. You will be receiving emails from payment providers such as Bill.com and a download link for our driver application. Welcome aboard.",
                            onCloseModal: this.onCloseModal,
                            buttonConfirm: "OK"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-lg-6 offset-lg-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "business-registration-form",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                children: "Become an Installer"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "intro",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: "Complete and submit the form below."
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: "Please only submit this form if you can officially represent the business or yourself."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "form",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "group",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                children: "Contact Information"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                                                children: "*Required Fields"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "row mt-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "col-12 col-sm-6",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_checkout_components_TextInput_text_input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                                label: "First Name*",
                                                                                value: firstName,
                                                                                placeholder: "First Name",
                                                                                name: "firstName",
                                                                                onChange: this.handleChange
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "validator-message-container",
                                                                                children: this.validator.message("First Name", firstName, "required")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "col-12 col-sm-6",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_checkout_components_TextInput_text_input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                                label: "Last Name",
                                                                                value: lastName,
                                                                                placeholder: "Last Name*",
                                                                                name: "lastName",
                                                                                onChange: this.handleChange
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "validator-message-container",
                                                                                children: this.validator.message("Last Name", lastName, "required")
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "row mt-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "col-12 col-sm-6",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_checkout_components_TextInput_text_input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                            label: "company",
                                                                            value: businessName,
                                                                            placeholder: "Company",
                                                                            name: "businessName",
                                                                            onChange: this.handleChange
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "col col-sm-6",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_checkout_components_PhoneInput_phone_input__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                                                validationError: this.validator.message("phone", this.state.phoneNumber, "required|phone"),
                                                                                id: "".concat(this.props.name, "Phone"),
                                                                                label: "Phone",
                                                                                labelAfterInput: true,
                                                                                value: this.state.phoneNumber,
                                                                                placeholder: "Phone Number",
                                                                                onChange: function(phone) {
                                                                                    return _this.setState({
                                                                                        phoneNumber: phone
                                                                                    });
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "validator-message-container",
                                                                                children: this.validator.message("Phone", phoneNumber, "required")
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "row mt-3",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "col-12",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_checkout_components_EmailInput_email_input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                                            placeholder: "Email*",
                                                                            type: "email",
                                                                            name: "email",
                                                                            value: email,
                                                                            onChange: this.handleChange
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "validator-message-container",
                                                                            children: this.validator.message("Email", email, "required|email")
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "group mb-0",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                children: "Address Information"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                                                children: "*Required Fields"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "mt-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .ZP, {
                                                                        value: this.state.country,
                                                                        options: this.props.countries,
                                                                        placeholder: "Country",
                                                                        getOptionLabel: function(param) {
                                                                            var country = param.country;
                                                                            return country;
                                                                        },
                                                                        getOptionValue: function(param) {
                                                                            var country_iso2 = param.country_iso2;
                                                                            return country_iso2;
                                                                        },
                                                                        onChange: function(value) {
                                                                            return _this.setState({
                                                                                country: value,
                                                                                state: ""
                                                                            });
                                                                        },
                                                                        isClearable: false,
                                                                        isSearchable: false
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "validator-message-container",
                                                                        children: this.validator.message("Country", country, "required")
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "mt-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_checkout_components_TextInput_text_input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                        label: "Address Line 1",
                                                                        value: addressLine1,
                                                                        placeholder: "Address Line 1*",
                                                                        name: "addressLine1",
                                                                        onChange: this.handleChange
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "validator-message-container",
                                                                        children: this.validator.message("Address Line 1", addressLine1, "required")
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "mt-3",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_checkout_components_TextInput_text_input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                    label: "Address Line 2",
                                                                    value: addressLine2,
                                                                    placeholder: "Address Line 2",
                                                                    name: "addressLine2",
                                                                    onChange: this.handleChange
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "row mt-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "col-6 col-sm",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_checkout_components_TextInput_text_input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                                label: "City",
                                                                                value: city,
                                                                                placeholder: "City*",
                                                                                name: "city",
                                                                                onChange: this.handleChange
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "validator-message-container",
                                                                                children: this.validator.message("City", city, "required")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "col-6 col-sm",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .ZP, {
                                                                                getOptionLabel: function(param) {
                                                                                    var state_abbreviation = param.state_abbreviation;
                                                                                    return state_abbreviation;
                                                                                },
                                                                                getOptionValue: function(param) {
                                                                                    var state_abbrevation = param.state_abbrevation;
                                                                                    return state_abbrevation;
                                                                                },
                                                                                options: this.state.country ? this.state.country.states : [],
                                                                                placeholder: "State",
                                                                                onChange: function(value) {
                                                                                    return _this.setState({
                                                                                        state: value
                                                                                    });
                                                                                },
                                                                                isClearable: false,
                                                                                isSearchable: false
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "validator-message-container",
                                                                                children: this.validator.message("State", state, "required")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "col-12 col-sm",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_checkout_components_TextInput_text_input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                                label: "Postal Code",
                                                                                value: postalCode,
                                                                                placeholder: "Postal Code*",
                                                                                name: "postalCode",
                                                                                onChange: this.handleChange
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "validator-message-container",
                                                                                children: this.validator.message("Postal Code", postalCode, "required")
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "mt-3 text-right",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                                    className: "btn",
                                                                    disabled: this.state.loading,
                                                                    onClick: function() {
                                                                        return _this.submitForm();
                                                                    },
                                                                    children: [
                                                                        this.state.loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                                    className: "fas fa-circle-notch fa-spin"
                                                                                }),
                                                                                " Processing..."
                                                                            ]
                                                                        }),
                                                                        !this.state.loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            children: "Submit"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return AddInstaller;
}(_src_components_page__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z);
var mapDispatchToProps = function(dispatch) {
    return {
        setSearchValue: function(payload) {
            return dispatch(_src_redux_actions_search__WEBPACK_IMPORTED_MODULE_25__/* .setSearchValue */ .gI(payload));
        },
        setFilterValue: function(payload) {
            return dispatch(_src_redux_actions_filters__WEBPACK_IMPORTED_MODULE_26__/* .setFilterValue */ .hL(payload));
        },
        setCountries: function(data) {
            return dispatch(_src_redux_constants_actiontypes__WEBPACK_IMPORTED_MODULE_27__/* .RECEIVE_COUNTRIES */ .Mr);
        }
    };
};
var mapStateToProps = function(state) {
    return {
        categories: state.categories.allCategories,
        brands: state.brands.brands,
        countries: state.countries.countries,
        geolocation: state.geolocation
    };
};
/* harmony default export */ __webpack_exports__["default"] = ((0,_lib_withPage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)((0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(AddInstaller)));


/***/ }),

/***/ 53775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EmailInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _InputContainer_input_container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(831);







var EmailInput = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(EmailInput, _PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(EmailInput);
    function EmailInput() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, EmailInput);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(EmailInput, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InputContainer_input_container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    validationError: this.props.validationError,
                    id: this.props.id,
                    label: this.props.label,
                    labelAfterInput: this.props.labelAfterInput,
                    body: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        name: this.props.name,
                        placeholder: this.props.placeholder,
                        type: "email",
                        id: this.props.id,
                        value: this.props.value || "",
                        required: true,
                        onChange: this.props.onChange,
                        onBlur: this.props.onBlur,
                        className: "form-control ".concat(this.props.validationError ? "error" : "")
                    })
                });
            }
        }
    ]);
    return EmailInput;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);



/***/ }),

/***/ 831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InputContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _input_container_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78574);
/* harmony import */ var _input_container_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_input_container_module_scss__WEBPACK_IMPORTED_MODULE_6__);







var InputContainer = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(InputContainer, _PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(InputContainer);
    function InputContainer() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, InputContainer);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(InputContainer, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "input-container-wrapper",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row-items",
                            children: [
                                !this.props.labelAfterInput && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                    htmlFor: this.props.id,
                                    className: (_input_container_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
                                    children: [
                                        this.props.label,
                                        " ",
                                        this.props.helpText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: (_input_container_module_scss__WEBPACK_IMPORTED_MODULE_6___default().helpText),
                                            children: [
                                                "(",
                                                this.props.helpText,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                this.props.body,
                                this.props.labelAfterInput && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                    htmlFor: this.props.id,
                                    className: (_input_container_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
                                    children: [
                                        this.props.label,
                                        " ",
                                        this.props.helpText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: (_input_container_module_scss__WEBPACK_IMPORTED_MODULE_6___default().helpText),
                                            children: [
                                                "(",
                                                this.props.helpText,
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        this.props.validationError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "alert alert-danger",
                            role: "alert",
                            children: this.props.validationError.props.children
                        })
                    ]
                });
            }
        }
    ]);
    return InputContainer;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);



/***/ }),

/***/ 19405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_phone_number_input_input__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91310);
/* harmony import */ var _InputContainer_input_container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(831);








var TextInput = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(TextInput, _PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(TextInput);
    function TextInput() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, TextInput);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(TextInput, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InputContainer_input_container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    validationError: this.props.validationError,
                    id: this.props.id,
                    label: this.props.label,
                    helpText: this.props.optional ? "Optional" : "",
                    width: this.props.width,
                    labelAfterInput: this.props.labelAfterInput,
                    body: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_phone_number_input_input__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                        disabled: this.props.disabled,
                        name: this.props.name,
                        country: "US",
                        type: this.props.type ? this.props.type : "tel",
                        id: this.props.id,
                        value: this.props.value || "",
                        required: !this.props.optional,
                        onChange: this.props.onChange,
                        placeholder: this.props.placeholder,
                        className: "form-control"
                    })
                });
            }
        }
    ]);
    return TextInput;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);



/***/ }),

/***/ 56073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _InputContainer_input_container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(831);







var TextInput = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(TextInput, _PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(TextInput);
    function TextInput() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, TextInput);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(TextInput, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InputContainer_input_container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    validationError: this.props.validationError,
                    id: this.props.id,
                    label: this.props.label,
                    helpText: this.props.optional ? "Optional" : "",
                    width: this.props.width,
                    labelAfterInput: this.props.labelAfterInput,
                    body: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        name: this.props.name,
                        type: this.props.type ? this.props.type : "text",
                        format: this.props.format,
                        id: this.props.id,
                        value: this.props.value || "",
                        required: !this.props.optional,
                        onChange: this.props.onChange,
                        placeholder: this.props.placeholder,
                        className: "form-control",
                        onFocus: this.props.onFocus,
                        onBlur: this.props.onBlur
                    })
                });
            }
        }
    ]);
    return TextInput;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);



/***/ }),

/***/ 38640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Icon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: "spinner-icon",
        viewBox: "0 0 50 50",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
            cx: "25",
            cy: "25",
            r: "20",
            fill: "none",
            strokeWidth: "5",
            className: "path"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 40456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_responsive_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31190);
/* harmony import */ var _loading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38640);




var FeedbackModal = function(param) {
    var open = param.open, type = param.type, title = param.title, content = param.content, onCloseModal = param.onCloseModal, buttonConfirm = param.buttonConfirm, buttonDecline = param.buttonDecline, confirmAction = param.confirmAction, declineAction = param.declineAction, isLoading = param.isLoading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "feedback-modal-container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_responsive_modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            classNames: {
                modal: "feedback-modal ".concat(type === "alert" ? "alert" : type === "info" ? "info" : ""),
                closeButton: "close-btn"
            },
            open: open,
            onClose: onCloseModal,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "inner",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "icon",
                        children: type === "alert" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "fad fa-exclamation-triangle"
                        }) : type === "info" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "fad fa-info-circle"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "fad fa-info-circle"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: content
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "buttons",
                                children: [
                                    buttonDecline && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "btn btn-default",
                                        onClick: function() {
                                            return declineAction();
                                        },
                                        children: buttonDecline
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        disabled: isLoading ? true : false,
                                        className: "btn btn-confirm",
                                        onClick: function() {
                                            return confirmAction("id");
                                        },
                                        children: [
                                            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_loading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: buttonConfirm
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FeedbackModal);


/***/ }),

/***/ 78574:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"input-container_container__eoVfQ","fullWidth":"input-container_fullWidth__nOh6f","twoThirdWidth":"input-container_twoThirdWidth__RG72b","halfWidth":"input-container_halfWidth__Er2t4","oneThirdWidth":"input-container_oneThirdWidth__PKzjO","label":"input-container_label__E0eeg","helpText":"input-container_helpText__VwNH6"};

/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [529,7219,5604,1310,3366,9774,2888,179], function() { return __webpack_exec__(76362); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);